import { render, staticRenderFns } from "./returnproduct.vue?vue&type=template&id=cf317910&scoped=true&"
import script from "./returnproduct.vue?vue&type=script&lang=js&"
export * from "./returnproduct.vue?vue&type=script&lang=js&"
import style0 from "./returnproduct.vue?vue&type=style&index=0&id=cf317910&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf317910",
  null
  
)

export default component.exports